// src/utils/chartConfig.js
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  PointElement,
  LineElement,
  BarElement, 
  ArcElement,
  Title, 
  Tooltip, 
  Legend 
} from 'chart.js';

// Register all Chart.js components in one place to avoid conflicts
ChartJS.register(
  CategoryScale, 
  LinearScale, 
  PointElement,
  LineElement,
  BarElement, 
  ArcElement,
  Title, 
  Tooltip, 
  Legend
);

// Export the registered ChartJS instance
export default ChartJS;

// Export renamed Tooltip to avoid conflicts with MUI Tooltip
export const ChartTooltip = Tooltip;
